<template>
  <div class="contributionDetail">
    <van-tabs v-model="settledType" @change="onRefresh()">
      <van-tab title="已结算" name="1"></van-tab>
      <van-tab title="待结算" name="2"></van-tab>
    </van-tabs>
    <div class="datastaticts">
      <div class="item">
        <span class="number">{{ listNum.total || '0' }}</span>
        <span>件数合计(件)</span>
      </div>
      <div class="item">
        <div>
          <span class="number">{{ parseInt(listNum.recommendAward || '0.00') }}.</span>
          <span class="number2">{{ getLastNum(listNum.recommendAward || '0.00') }}</span>
        </div>
        <span v-if="settledType=='1'">{{$tools.isRYBB()?'活动':'推荐'}}奖合计(元)</span>
        <span v-if="settledType=='2'">{{$tools.isRYBB()?'活动':'推荐'}}奖合计(预计)</span>
      </div>
    </div>
    <div class="content-list">
      <div class="null" v-if="list.length <= 0 && !listLoading">
        <img class="null-img" src="@static/images/null.png" />
        <span class="null-text">暂无数据</span>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-else>
        <van-list
          v-model="listLoading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :offset="10"
          :immediate-check="false"
        >
          <div>
            <div v-for="(item) in list" :key="item.id" class="closeList" @click="toPage(item)">
              <div class="item-num">
                <div>承保时间：{{item.insureTime | dateFormat("yyyy/MM/dd")}}</div>
                <div v-if="item.status == 1" class="item-num-state">已承保</div>
                <div v-if="item.status == -1" class="item-num-state" style="color: #999999">已退保</div>
                <div v-if="item.status == 0" class="item-num-state" style="color: #999999">已终止</div>
              </div>
              <div>
                <div class="item-name">{{item.productName}}</div>
                <div class="insuranceName" v-if="settledType == '1'">
                  <div class="items">
                    <div>险种名称：</div>
                    <span>{{item.insuranceName}}</span>
                  </div>
                </div>
                <div class="item-detail">
                  <div class="item-detail-info">
                    <div class="items">
                      <div>出单人：</div>
                      <span>{{item.userName}}</span>
                    </div>
                    <div class="items">
                      <div>保费：</div>
                      <span>{{item.fee}}元</span>
                    </div>  
                    <div class="items">
                      <div>保单号：</div>
                      <span>{{item.policyNo}}</span>
                    </div>  
                    <div v-if="item.billNo" class="items">
                      <div>批单号：</div>
                      <span>{{item.billNo}}</span>
                    </div>
                  </div>
                  <div class="serviceFee">
                    <div>{{item.award.indexOf('-') == -1?'+':''}}{{item.award}}元</div>
                    <div>{{$tools.isRYBB()?'活动':'推荐'}}奖</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      settledType:'1',
      listNum:{},
      list:[],
      isLoading: false,
      finished: false,
      listLoading:false,
      pageNo:1,
      pageSize: 10,
      totalNo:''
    }
  },
  mounted(){
    this.$tools.setWebTitle(this.$route.query.title);
    this.onRefresh()
  },
  methods:{
    // 获取小数 保留末位0
    getLastNum(num) {
      return ("00" + ((num * 100).toFixed(2) % 100)).substr(-2);
    },
    onRefresh() {
      this.list = [];
      this.finished = false;
      this.isLoading = true;
      this.$tools.cancelhttpRequest();
      // 重新加载数据
      this.getList();
    },
    getList() {
      this.listLoading = true;
      if (this.isLoading) {
        this.list = [];
        this.pageNo = 1;
        this.isLoading = false;
        this.getTotalNum()
      }
      this.$http({
        type: "POST",
        url: "/app/okbao/recommendAward/queryDetail",
        data: {
          userId:this.$route.query.id,
          settledType:this.settledType,
          pageNo:this.pageNo,
          pageSize:this.pageSize
        },
      })
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            this.list.push(res.data[i]);
          }
          this.isLoading = false;
          this.listLoading = false;
          this.totalNo = res.pages;
          if (this.list.length >= res.total) {
            this.finished = true;
          }
        })
        .catch((err) => {
          this.finished = true;
          this.isLoading = true;
          this.listLoading = false;
        });
    },
    onLoad() {
      if (this.pageNo == this.totalNo) {
				this.finished = true;
				return;
			}
      this.pageNo++;
      this.getList();
    },
    getTotalNum(){
      this.listNum ={
        total:0,
        recommendAward:'0.00'
      }
      this.$http({
        type: 'POST',
        url: '/app/okbao/recommendAward/statistic',
        data: {
          userId:this.$route.query.id,
          settledType:this.settledType
        }
      }).then(res => {
        if (res.data) {
          this.listNum = res.data;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.contributionDetail{
  background: #F5F5F5;
  height: 100vh;
  .datastaticts{
    margin: 20px 30px;
    padding: 30px 0;
    width: 690px;
    height: 150px;
    background: url('~@/static/images/activityCenter/background3.png');
    background-size: cover;
    font-size: 24px;
    color: #D1763B;
    display: flex;
    align-items: center;
    .item{
      display: flex;
      flex-direction: column;
      padding-left: 40px;
      
      &:first-child{
        padding-right: 120px;
      }
      &:last-child{
        border-left: 1px solid #F5D6BE;
      }
      .number {
        font-size: 35px;
        color: #ff5426;
        font-weight: bold;
      }
      .number2 {
        margin-top: 4px;
        font-size: 28px;
        font-weight: bold;
        color: #ff5426;
      }
    }
  }
  .content-list {
    padding: 0px 30px 30px 30px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    height: calc(100vh - 280px);
  }
  .closeList {
    width: 100%;
    border-radius: 10px;
    margin: 20px 0;
    background: #ffffff;
  }
  .item-num {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    height: 70px;
    color: #666666;
    font-size: 26px;
    border-bottom: 1px solid #ececec;
  }
  .item-num-state {
    color: #236dff;
  }
  .item-name {
    font-size: 32px;
    color: #000;
    font-weight: bold;
    margin: 10px 30px 10px 30px;
  }
  .item-detail {
    display: flex;
    align-items: center;
    padding: 0 30px 20px 30px;
  }
  .item-detail-info {
    flex: 1;
    color: #888888;
    font-size: 28px;
    padding-right: 6px;
    .items{
      display: flex;
    }
  }
  .item-detail-info span {
    color: #333333;
    max-width: 270px;
    word-break: break-word;
  }
  .item-divide {
    width: 0px;
    height: 80px;
    opacity: 1;
    border: 1px solid #dddddd;
    margin: 0 10px;
  }
  .serviceFee {
    border-left: 1px solid #dee2ea;
    padding-left: 30px;
    min-width: 200px;
  }
  .serviceFee > div {
    width: 100%;
    text-align: center;
    font-size: 24px;
    color: #666666;
  }
  .serviceFee > div:first-child {
    font-size: 30px;
    color: #ff5426;
    font-weight: 700;
  }
  .insuranceName{
    padding: 0 30px;
    color: #888888;
    font-size: 28px;
    .items{
      display: flex;
    }
    span {
      display: block;
      color: #333333;
      max-width: 480px;
      word-break: break-word;
    }
  }
}
/deep/ .van-tabs__line{
  bottom: 0;
}
</style>